// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogArticleListingSmallHeader_wrapper__FUhNs"};